import './nav-scroller.scss';

class NavScroller {
    constructor (element) {
        this.$navScroller = element;
        this.$navScrollerList = this.$navScroller.querySelector('[data-nav-scroller="list"]');
        this.$buttonPrev = this.$navScroller.querySelector('[data-nav-scroller="prev"]');
        this.$buttonNext = this.$navScroller.querySelector('[data-nav-scroller="next"]');
        this.$scrollItems = Array.from(this.$navScrollerList.children);
        this.startScroll = true;
        this.endScroll = false;
    }

    initialize () {
        this.scrollCheck();
        this.setEvents();
    }

    scrollCheck () {
        const scrollLeft = this.$navScrollerList.scrollLeft;
        const scrollWidth = this.$navScrollerList.scrollWidth;
        const listWidth = this.$navScrollerList.offsetWidth;
        const endScroll = scrollWidth - listWidth - 10;

        const lastScroll = scrollWidth - listWidth - 100;
        const startScroll = scrollLeft - 100;

        if (scrollLeft > 10) {
            this.$buttonPrev.classList.add('show-left-shadow');
        } else {
            this.$buttonPrev.classList.remove('show-left-shadow');
        }

        if (scrollLeft > endScroll) {
            this.$buttonNext.classList.add('hide-right-shadow');
        } else {
            this.$buttonNext.classList.remove('hide-right-shadow');
        }

        if (startScroll < 100) {
            this.startScroll = true;
        } else {
            this.startScroll = false;
        }

        if (scrollLeft + 100 > lastScroll) {
            this.endScroll = true;
        } else {
            this.endScroll = false;
        }
    }

    setEvents () {
        [1280, 1024, 768, 480, 375, 320].forEach((bp) => {
            window.mediaMatch[bp].addEventListener('change', () => {
                this.scrollCheck();
            });
        });

        this.$navScrollerList.addEventListener('scroll', () => {
            this.scrollCheck();
        }, { passive: true });

        if (this.$scrollItems.length) {
            this.$buttonPrev.onclick = () => {
                if (this.startScroll === false) {
                    this.$navScrollerList.scrollLeft -= 100;
                } else {
                    this.$navScrollerList.scrollLeft = 0;
                }
            };

            this.$buttonNext.onclick = () => {
                if (this.endScroll === false) {
                    this.$navScrollerList.scrollLeft += 100;
                } else {
                    this.$navScrollerList.scrollLeft = this.$navScrollerList.scrollWidth;
                }
            };
        }
    }
}

export { NavScroller };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$navScroller = $context.querySelectorAll('[data-nav-scroller="root"]');

        if ($$navScroller.length > 0) {
            $$navScroller.forEach(($navScroller) => {
                const navScroller = new NavScroller($navScroller);
                navScroller.initialize();
            });
        }
    }
});
